module.exports = __webpack_public_path__ + "img/circle.ef13f8fb.gif";